<template>
  <ul class="leftNav">
    <li
      class="list"
      v-for="(item, index) in list"
      :key="index"
      @click="setPath(item.path)"
    >
      <router-link :to="item.path">
        <p class="flex">
          <img
            v-if="item.path == path"
            style="width: 30px; height: 28px"
            :src="require(`../assets/icon/${item.icon}.png`)"
            alt=""
          />
          <img
            v-else
            style="width: 30px; height: 28px"
            :src="require(`../assets/icon/${item.icon}1.png`)"
            alt=""
          />
        </p>
        <p class="listName">{{ item.name }}</p>
        <p class="bg"></p>
      </router-link>
    </li>
    <!-- {{list}} -->
  </ul>
</template>

<script>
// import list from "./leftnav.js"
export default {
  watch: {
    $route(val) {
      let t = val;
      if (t) {
        if (typeof t == "string") {
          t = JSON.parse(val);
        }
        this.path = `/index/` + t.path.split("/")[2];
      }
    },
  },
  data() {
    return {
      list: [],
      path: "",
      oldPath: "",
      i: 0,
    };
  },
  methods: {
    setPath(path) {
      //修改vuex 属性告诉layout组件修改width
      // if (this.oldPath == path) {
      // 	this.i++
      // }
      // if (this.i % 2) {
      // 	this.$store.commit("setPath", true)
      // } else {
      // 	this.$store.commit("setPath", false)
      // }
      // this.oldPath = path;
      // return
      // if (this.oldPath == path) {
      // 	this.$store.commit("setPath", true)
      // } else {
      // 	this.$store.commit("setPath", false)
      // }
      // this.oldPath = path;
    },
    setRouter(list) {
      if (!list) {
        return;
      }
      console.log("list:", list);
      let arr = [];
      if (localStorage.deptId == 115) {
        arr.push({
          path: "/index/controller",
          name: "工作台",
          icon: "management",
          message: "",
        });
      }
      list.forEach((item) => {
        //console.log('localStorage.deptId:',localStorage.deptId)
        //console.log('item.path:',JSON.stringify(item.path))
        if (localStorage.deptId != 115) {
          arr.push({
            path: item.path,
            name: item.meta.title,
            icon: item.meta.icon,
            message: "",
          });
        } else if (item.path != "/index/console") {
          arr.push({
            path: item.path,
            name: item.meta.title,
            icon: item.meta.icon,
            message: "",
          });
        }
      });
      this.list = arr;
      //console.log(this.list)
    },
  },
  created() {
    if (!localStorage.access_token) {
      console.log("leftnav跳转到登录界面");
      this.$router.push("/login");
    } else {
      this.$http.get("/api/system/menu/getRouters").then((res) => {
        let b = [];
        res.data.data.forEach((val) => {
          if (
            val.meta.title != "系统管理" &&
            val.meta.title != "流程管理" &&
            val.meta.title != "支付网关" &&
            val.meta.title != "系统监控" &&
            val.meta.title != "任务管理" &&
            val.meta.title != "应用配置"
          ) {
            b.push(val);
          }
        });
        this.setRouter(b);
        console.log("cd:", b);
        localStorage.setItem("cd", JSON.stringify(b));
      });
      // setTimeout(() => {
      // 	if (localStorage.deptId != 115) {
      // 		this.$router.push("/index/console")
      // 	}

      // }, 2000)
    }

    //老代码
    // this.path = `/index/` + this.$route.path.split("/")[2]
    // this.$http.get(`/api/api/getMenuByRoleId?roleId=${sessionStorage.roleId}`).then(res => {
    // 	this.setRouter(res.data.data)
    // })
  },
};
</script>

<style scoped>
.router-link-active .bg {
  display: block;
}

.leftNav {
  color: #40485b;
  font-size: 12px;
  padding-top: 10px;
  background-color: #fff;
  height: calc(100vh - 65px);
}

.list {
  text-align: center;
  padding: 8px 0 8px 3px;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  flex-flow: column;
}

.bg {
  display: none;
  position: absolute;
  width: 3px;
  background-image: url(../assets/icon/line_menu.jpg);
  height: 100%;
  top: 0;
  left: 0px;
}

.flex {
  font-size: 0;
  padding-bottom: 9px;
  display: flex;
  justify-content: center;
}

.show {
  position: absolute;
  left: 73px;
  top: 15px;
  background-color: rgba(0, 0, 0, 0.8);
  height: 35px;
  line-height: 35px;
  white-space: nowrap;
  color: white;
  font-size: 12px;
  padding: 0 10px;
  border-radius: 4px;
  z-index: 999;
}

.icon {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 12px;
  left: -4px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid rgba(0, 0, 0, 0.8);
  border-left: 5px solid rgba(0, 0, 0, 0.8);
  border-right: 5px solid transparent;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  /* IE 9 */
  -moz-transform: rotate(45deg);
  /* Firefox */
  -webkit-transform: rotate(45deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(45deg);
  /* Opera */
}

.bg {
  width: 3px;
  background-color: #fe7300;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
}

.listName {
  white-space: nowrap;
}
</style>
